<div aria-label="class-client-booking-container">
    <!-- Tabs -->
    <ul class="list-none p-0 m-0 hidden md:flex text-600 text-sm white-space-nowrap overflow-x-auto" aria-label="status-tabs">
      <ng-container *ngFor="let status of GetMemberStatus">
      <li class="cursor-pointer xl:px-3 mr-3 p-2 hover:text-primary"
        [ngClass]="selectedMemberStatus !== null  && selectedMemberStatus === status ? 'border-bottom-2 border-primary text-900 font-bold' : ''"
        (click)="ToggleButton(status)" [attr.aria-label]="'status-tab-' + status.name">
        {{'SCHEDULE.VIEWCLASS.'+status.name | translate  }} {{status.count}}
      </li>
    </ng-container>
    </ul>
    <!-- Tabs -->

    <!-- Tabs Mobile -->
    <ul class="list-none p-0 m-0 flex md:hidden text-600 text-sm white-space-nowrap overflow-x-auto" aria-label="mobile-status-tabs">
      <ng-container *ngFor="let status of GetMemberStatus">
      <li class="cursor-pointer xl:px-3 mr-3 p-2 bg-primary md:surface-0 text-white md:text-600 border-round"
        [ngClass]="selectedMemberStatus !== null  && selectedMemberStatus === status ? 'border-bottom-2 border-primary text-900 font-bold' : ''"
        (click)="ToggleButton(status)" [attr.aria-label]="'mobile-status-tab-' + status.name">
        {{'SCHEDULE.VIEWCLASS.'+status.name | translate  }} {{status.count}}
      </li>
    </ng-container>
    </ul>
    <!-- Tabs Mobile -->

    <!-- Search Box -->
    <div class="surface-400 p-2 md:p-3" *ngIf="(showMiniSearch | async)" [ngClass]="isClassCompletedOrCancelled ? 'pointer-events-none' :'' " aria-label="client-search-section">
      <div class="relative z-2">
        <!-- Input Field -->
        <mini-search class="p-input-icon-right w-full" [showCreateClient]="false" [readonly]="false" [showSelected]="false" (clients)="AddClient($event)"  (createProspect)="createProspect($event)" aria-label="client-search-input">
        </mini-search>
        <!-- Input Field -->
      </div>
    </div>

    <div class="px-3" *ngIf="(showMiniSearch | async) === false" aria-label="search-loading">
      <p-skeleton height="3rem" styleClass="mb-2"></p-skeleton>
    </div>
    <!-- Search Box -->

    <!-- User Detail Header -->
    <div class="surface-300 text-600 uppercase font-bold text-xs hidden md:flex align-items-center" aria-label="user-details-header">
      <div class="w-4 p-3" aria-label="client-name-header">{{'SCHEDULE.VIEWCLASS.CLIENT_NAME' | translate}}</div>
      <div class="w-4 p-3" aria-label="payment-status-header">{{'SCHEDULE.VIEWCLASS.PAYMENT_STATUS' | translate}}</div>
      <div class="w-4 p-3" aria-label="subscription-header">{{'SCHEDULE.VIEWCLASS.SUBSCRIPTION' | translate}}</div>
    </div>
    <!-- User Detail Header -->

    <!-- <div *ngIf="showLoader$ | async" class="left-0 top-0 z-5 flex align-items-center surface-0 justify-content-center w-full h-full">
       <p-progressSpinner></p-progressSpinner>  
    </div> -->

    <p-scrollPanel styleClass="w-full overflow-hidden h-screen xl:h-30rem" *ngIf="(showLoader$ | async)" aria-label="loading-panel">
      <div class="left-0 top-0 z-5 flex align-items-center surface-0 justify-content-center w-full h-full">
       <p-progressSpinner aria-label="loading-spinner"></p-progressSpinner>  
      </div>
    </p-scrollPanel>

    <!-- Scroll -->
    <p-scrollPanel styleClass="w-full overflow-hidden h-screen xl:h-30rem" *ngIf="getClients && getClients.length > 0; else noclients" aria-label="clients-list">
      <ul class="list-none my-0 ml-0 xl:-mr-2 px-0 pt-0 pb-5 text-xs md:text-sm">
        <ng-container *ngFor="let client of getClients; let i = index">
        <li class="md:flex align-items-start md:align-items-center justify-content-between py-2 md:py-3 border-bottom-1 border-300 relative" [attr.aria-label]="'client-item-' + client.class_booking_client_Id">
          <!-- Client Name -->
          <div class="md:w-4 px-3 pb-1 xl:pb-0 xl:px-2" aria-label="client-info">
            <div class="flex align-items-center">
              <p-avatar *ngIf="client.image; else noContactPic" [image]="client.image" shape="round" [attr.aria-label]="'client-avatar-' + client.class_booking_client_Id"></p-avatar>
              <ng-template #noContactPic>
                <p-avatar [label]="client.full_name | titlecase | shortName" shape="round" [attr.aria-label]="'client-avatar-' + client.class_booking_client_Id"></p-avatar>
              </ng-template>
              <div class="ml-2 w-full md:w-auto flex align-items-center justify-content-between md:block">
                <div class="mr-2 text-sm">
                  <strong class="cursor-pointer text-primary" [attr.aria-label]="'client-name-' + client.class_booking_client_Id">{{client.full_name}}</strong>
                  <span class="text-xs text-600 ml-2 font-normal" [attr.aria-label]="'client-id-' + client.class_booking_client_Id"> - {{client.class_booking_client_Id}}</span>
                </div>

                <div class="flex align-items-center md:mt-2 ml-2 md:ml-0">
                  <!-- <span class="bg-green-600 px-2 py-1 font-bold border-round text-white text-xxs">MEMBER</span> -->
                  <div [innerHTML]="clientStatus(client)" [attr.aria-label]="'client-status-' + client.class_booking_client_Id"></div>
                  <div class="hidden md:flex align-items-center ml-2">
                    <span class="w-1rem h-1rem border-circle flex align-items-center justify-content-center surface-400 mr-1" [attr.aria-label]="'first-time-icon-' + client.class_booking_client_Id">
                      <i class="fa fa-star-fill text-primary text-xxs"></i>
                    </span>
                    <span class="text-xs text-600" *ngIf="client.class_booking_is_first_time_class" [attr.aria-label]="'first-time-text-' + client.class_booking_client_Id">
                      {{'SCHEDULE.VIEWCLASS.FIRST_TIME' | translate}}
                    </span>
                  </div>
                </div>

              </div>
            </div>

          </div>
          <!-- Client Name -->

          <!-- Payment Status -->
          <div class="md:w-4 flex py-2 md:py-0 px-2 align-items-center md:justify-content-start justify-content-between" aria-label="payment-status">
            <div class="flex align-items-center w-6rem" >
              <span class="w-1rem h-1rem border-circle bg-green-600" [attr.aria-label]="'payment-status-icon-' + client.class_booking_client_Id"></span>
              <span class="text-xs text-600" *ngIf="!client.class_booking_is_payment_required" aria-label="'no-dues-text">{{'SCHEDULE.VIEWCLASS.NO_DUES' | translate}}</span>
              <span class="text-xs text-600" *ngIf="client.class_booking_is_payment_required" aria-label="'pending-pay-text">{{'SCHEDULE.VIEWCLASS.PENDING_PAY' | translate}}</span>
            </div>

            <div class="flex md:hidden align-items-center ml-2" *ngIf="client.class_booking_is_first_time_class">
              <span class="w-1rem h-1rem border-circle flex align-items-center justify-content-center surface-400 mr-2" [attr.aria-label]="'mobile-first-time-icon-' + client.class_booking_client_Id">
                <i class="fa fa-star-fill text-primary text-xxs"></i>
              </span>
              <span class="text-xs text-600" [attr.aria-label]="'mobile-first-time-text-' + client.class_booking_client_Id"> {{'SCHEDULE.VIEWCLASS.FIRST_TIME' | translate}}</span>
            </div>
            <div class="flex align-items-center mr-1" *ngIf="client.class_booking_cp_booking" [attr.aria-label]="'mobile-classpass-booking-' + client.class_booking_client_Id">
              <img src="/assets/img/classpass_compact.svg" alt="ClassPass booking" class="w-4rem h-4rem" style="object-fit: contain;" />
            </div>
            <div *ngIf="client.medical_alert" (click)="GetClietMedicalDetails(client)" 
                class="ml-1 flex align-items-center cursor-pointer text-primary text-xs" [attr.aria-label]="'medical-alert-' + client.class_booking_client_Id">
              <img src="/assets/img/icons/icon-medical-alert.svg" alt="Medical alert" />
              <span class="ml-2">{{'EDIT_CLIENT_PROFILE.MEDICAL_ALERT' | translate}}</span>
            </div>
          </div>
          <!-- Payment Status -->

          <hr class="border-300 border-top-1 border-bottom-none border-left-none border-right-none mt-0 mb-2 md:hidden">

          <!-- Subcription -->
          <div [formGroup]="clientMembershipForm" [ngClass]=" client.memberships ? '': 'md:mr-3'"
           class="flex align-items-center md:w-4 px-3 xl:px-2 justify-content-between" aria-label="subscription-section">
            <p-select *ngIf="client.memberships && client.memberships.length > 1 && client.class_booking_status !== 'Cancelled'; else showServiceName" [options]="client.memberships"
              formControlName='clientMembership_{{client.class_booking_client_Id}}'
              optionLabel="subscription_primary_name" filterBy="subscription_primary_name"
              styleClass="text-sm w-10rem md:w-7rem" placeholder="Choose Subscription"
              (onChange)="ChangeMembership($event, client)" aria-label="'subscription-dropdown">
              <ng-template pTemplate="selectedItem">
                <div class="text-sm ml-2 w-4rem overflow-hidden white-space-nowrap">
                  {{clientMembershipForm.get('clientMembership_'+client.class_booking_client_Id)?.value.subscription_primary_name }} - {{ clientMembershipForm.get('clientMembership_'+client.class_booking_client_Id)?.value.service_category_primary_name}}
                </div>
              </ng-template>
              <ng-template let-membership pTemplate="item">
                <div class="text-sm ml-2 w-4rem overflow-hidden white-space-nowrap" pTooltip="{{membership.subscription_primary_name }} - {{membership.service_category_primary_name}}" tooltipPosition="left" tooltipStyleClass="text-xs">
                  {{membership.subscription_primary_name }} - {{membership.service_category_primary_name}}</div>
              </ng-template>
            </p-select>

            <ng-template #showServiceName>
              <div class="text-sm ml-2" *ngIf="client.selectedMembership" [attr.aria-label]="'selected-subscription-' + client.class_booking_client_Id">
                {{client.selectedMembership.subscription_primary_name || client.selectedMembership.subscription_secondary_name}} - {{client.selectedMembership.service_category_primary_name}}
              </div>
              <div class="text-sm text-center" *ngIf="!client.selectedMembership"></div>
            </ng-template>
          
            <div class="pr-2" *ngIf="client.class_booking_status !== 'Cancelled'"> 
              <button pButton pRipple type="button" icon="fa fa-angle-down" [label]="'common.BUTTONS.BTN_ACTIONS' | translate" iconPos="right"
                class="surface-0  p-button-outlined border-400 ml-2 text-600 text-sm"
                (click)="member1.toggle($event)" aria-label="'client-actions-button">
              </button>
              <p-popover #member1 styleClass="overflow-hidden right-0 text-sm w-13rem" aria-label="client-actions-panel">
                <ng-template #content>
                  <ul class="list-none -m-4 px-0 py-2 text-xs text-600">
                    <li class="cursor-pointer hover:surface-300 py-2 px-3 flex align-items-center" *ngIf="client.class_booking_status.toLowerCase() !== 'attended'"
                      (click)="MarkClientCheckedIn(client,$event)" aria-label="'check-in-button">
                      <i class="fa fa-sign-in text-500 mr-2"></i>
                      {{'SCHEDULE.VIEWCLASS.CHECK_IN' | translate}}
                    </li>
                    <li class="cursor-pointer hover:surface-300 py-2 px-3 flex align-items-center"
                      (click)="MarkClientNoshow(client,$event)" aria-label="'no-show-button">
                      <i class="fa fa-times text-xl-circle text-500 mr-2"></i>{{'SCHEDULE.VIEWCLASS.NO_SHOW' | translate}}
                    </li>
                    <li class="cursor-pointer hover:surface-300 py-2 px-3 flex align-items-center"
                      (click)="RemoveClientFromClass(client,$event)" aria-label="'remove-client-button">
                      <i class="fa fa-minus-circle text-500 mr-2"></i>{{'SCHEDULE.VIEWCLASS.REMOVE' | translate}}
                    </li>
                    <li
                    *ngIf="client.class_booking_status.toLowerCase() === 'attended' || client.class_booking_status.toLowerCase() === 'noshow'"
                    (click)="MarkAsCompSession(client,$event)"
                    class="cursor-pointer hover:surface-300 py-2 px-3 flex align-items-center" aria-label="'comp-session-button">
                    <i class="fa fa-calendar-times text-500 mr-2"></i> {{ 'CLIENT_BOOKING.ACTIONS.COMPSESSION' | translate }}
                  </li>
                  </ul>
                </ng-template>
              </p-popover>
            </div>
          </div>
          <!-- Subcription -->

        </li>
      </ng-container>
      </ul>
    </p-scrollPanel>

    <ng-template #noclients>
      <p-scrollPanel styleClass="w-full overflow-hidden h-screen xl:h-30rem" *ngIf="(showLoader$ | async) === false" aria-label="no-clients-message">
        <p class="mb-0 text-center font-bold mt-5">{{'SCHEDULE.VIEWCLASS.ADD_CLIENTS' | translate}}</p>
      </p-scrollPanel>
    </ng-template>
<!-- 
    <p-progressSpinner *ngIf="showLoader" styleClass="w-4rem h-4rem" strokeWidth="8" fill="var(--surface-ground)" animationDuration=".5s"></p-progressSpinner> -->

    <!-- Scroll -->

  </div>

  <!-- Footer -->
  <div class="w-full flex flex-wrap justify-content-center md:justify-content-start bg-primary sticky right-0 bottom-0 w-full z-2 text-xs px-2 py-1 mt-3" aria-label="action-buttons-footer">

    <div class="w-12 md:w-4 py-2 px-1" [ngClass]="isClassCompletedOrCancelled ? 'pointer-events-none' :'' ">
      <div class="w-full cursor-pointer inline-flex  justify-content-center align-items-center py-3 px-2 border-round text-green-500 font-bold"
        (click)="MarkAllClientsAttended(markAllAttended)" [ngClass]="!markAllAttended ? 'surface-100' : 'bg-green-500 text-white' " aria-label="mark-all-attended-button">
        <i class="fa fa-user-plus mr-2 text-green-500" [ngClass]="markAllAttended ? 'text-white' : 'text-green-500' "></i>
         <span>
          <div *ngIf="!markAllAttended; else markNotAttended" [innerHTML]="'SCHEDULE.VIEWCLASS.MARK_BOOKED' | translate">
          </div>
          <ng-template #markNotAttended>
            <div>{{'SCHEDULE.VIEWCLASS.ALL_BOOKED' | translate}}</div>
          </ng-template>
        </span>
      </div>
    </div>

    <div class="w-6 md:w-4 py-2 px-1" [ngClass]="isClassCompletedOrCancelled ? 'pointer-events-none' :'' ">
      <div class="w-full cursor-pointer flex justify-content-center align-items-center py-3 px-2 border-round font-bold text-teal-500"
        (click)="MarkClassComplete(markCompleted)" [ngClass]="markCompleted ? 'bg-teal-500 text-white' : 'surface-0' " aria-label="mark-class-complete-button">
        <i class="fa fa-check-square mr-2" [ngClass]="markCompleted ? 'text-white' : 'text-teal-500' "></i> <span>
          <div *ngIf="!markCompleted; else markClassCompleted" [innerHTML]="'SCHEDULE.VIEWCLASS.MARK_COMPLETED' | translate">
          </div>
          <ng-template #markClassCompleted>
            {{'SCHEDULE.VIEWCLASS.COMPLETED' | translate}}
          </ng-template>
        </span>
      </div>
    </div>

    <div class="w-6 md:w-4 py-2 px-1 pointer-events-none">
      <div class="w-full cursor-pointer inline-flex justify-content-center align-items-center py-3 px-2 border-round text-600 font-bold"
        (click)="sendGroupMsgs = true" [ngClass]="sendGroupMsgs ? 'bg-green-600 text-white' : 'surface-100' " aria-label="send-group-messages-button">
        <i class="fa fa-comments font-light mr-2" [ngClass]="sendGroupMsgs ? 'text-white' : 'text-600' "></i> <span>
          <div *ngIf="!sendGroupMsgs; else groupMsgSent">{{'SCHEDULE.VIEWCLASS.SEND_GROUP_MSGS' | translate}}</div>
          <ng-template #groupMsgSent>{{'SCHEDULE.VIEWCLASS.MSG_SENT' | translate}}</ng-template>
        </span>
      </div>
    </div>
    <!-- Footer -->

  </div>



<!-- Show Add Client To Waitlist Modal -->
<p-dialog [(visible)]="showAddClientConfirmPopup" (onHide)="showAddClientConfirmPopup = false" [resizable]="false"
  appendTo="body" [modal]="true" [breakpoints]="{'767px': '100vw'}" [style]="{width: '470px'}"
  styleClass="no-header-modal" aria-label="add-client-waitlist-dialog">

  <ng-template pTemplate="header" styleClass="hidden"></ng-template>
  <ng-template pTemplate="content" styleClass="p-0">
    <!-- Content -->
    <div class="relative text-center px-4 py-5">
      <div class="fa fa-times text-xl opacity-50 absolute right-0 top-0 mt-3 mr-3 md:mt-4 md:mr-4 cursor-pointer"
        (click)="showAddClientConfirmPopup = false" aria-label="close-waitlist-dialog"></div>

      <i class="fa fa-exclamation-triangle p-error text-7xl mt-5" aria-label="warning-icon"></i>

      <h4 class="text-base md:text-lg mb-2 my-5 font-bold" aria-label="waitlist-confirmation-message">{{'SCHEDULE.VIEWCLASS.MSG.CONFIRM_WAITLIST_MSG' | translate}}
      </h4>
    </div>
    <!-- Content -->

    <!-- Modal Footer -->
    <div class="flex align-items-center justify-content-between px-4 py-3 border-top-1 border-300">
      <button pButton pRipple type="button" [label]="'common.BUTTONS.CANCEL-BUTTON-TEXT' | translate"
        class="p-button-secondary p-button-text text-sm" (click)="showAddClientConfirmPopup = false" aria-label="cancel-waitlist-button"></button>
      <button pButton pRipple type="button" [label]="'SCHEDULE.VIEWCLASS.CONTINUE' | translate"
        class="p-button-danger text-sm" (click)="AddClientToWaitlist()" aria-label="confirm-waitlist-button"></button>
    </div>
    <!-- Modal Footer -->
  </ng-template>
</p-dialog>
<!-- Show Add Client To Waitlist Modal -->

<!-- Medical ALert Modal -->
<p-dialog [(visible)]="showMedicalAlert" [resizable]="false" appendTo="body" [modal]="true"
  [breakpoints]="{'767px': '100vw'}" [style]="{width: '450px'}" styleClass="no-header-modal" (onHide)="showMedicalAlert= false;clientMedicalDetails=null" aria-label="medical-alert-dialog">

  <ng-template pTemplate="header" styleClass="hidden"></ng-template>
  <ng-template pTemplate="content" styleClass="p-0">
    <!-- Header -->
    <div class="p-3 flex align-items-center justify-content-between border-bottom-1 border-300">
      <div [innerHtml]="'SCHEDULE.VIEWCLASS.MEDICAL_ALERT_FOR' | translate :{name:clientMedicalDetails.full_name}" aria-label="medical-alert-header"></div>
      <div class="fa fa-times text-xl text-600 cursor-pointer" (click)="showMedicalAlert = false;clientMedicalDetails=null" aria-label="close-medical-alert"></div>
    </div>
    <!-- Header -->

    <!-- Content -->
    <div class="p-4 surface-50" [innerHtml]="clientMedicalDetails.medical_alert" aria-label="medical-alert-content">
    </div>
    <!-- Content -->
    
  </ng-template>

</p-dialog>
<!-- Medical Alert Modal -->

<!-- Comp Session -->
<p-dialog [(visible)]="showCompSessionPopup" [resizable]="false" appendTo="body" [modal]="true"
  [breakpoints]="{'767px': '100vw'}" [style]="{width: '500px'}" styleClass="no-header-modal overflow-visible" aria-label="comp-session-dialog">

  <ng-template pTemplate="header" styleClass="hidden"></ng-template>
  <ng-template pTemplate="content" styleClass="p-0">

    <form [formGroup]="complimentoryForm" aria-label="comp-session-form">
      <!-- Header -->
      <div class="px-4 py-3 flex align-items-center justify-content-between border-bottom-1 border-300">
        <h2 class="mb-0 text-base md:text-lg" aria-label="comp-session-title"> {{'CLIENT_BOOKING.HEADER' | translate}} </h2>
        <div class="fa fa-times text-xl text-600 cursor-pointer" (click)="closeCompSessionPopup()" aria-label="close-comp-session"></div>
      </div>
      <!-- Header -->

      <!-- Content -->
      <div class="surface-100 text-sm p-4">

        <label class="font-medium text-700 text-xs mb-2 block uppercase" aria-label="comp-reason-label">{{'CLIENT_BOOKING.COMP_REASON' | translate}}</label>
        <textarea pInputTextarea class="w-full h-5rem" formControlName="comments"
          [placeholder]="'CLIENT_BOOKING.COMP_REASON_PLACEHOLDER' | translate" aria-label="comp-reason-input"
        ></textarea>

      </div>
      <!-- Content -->


      <!-- Modal Footer -->
      <div class="flex align-items-center justify-content-between px-4 py-3 border-top-1 border-300">
        <button pButton pRipple type="button" [label]="'common.BUTTONS.CANCEL-BUTTON-TEXT' | translate"
          class="p-button-text text-sm" (click)="closeCompSessionPopup()" aria-label="cancel-comp-session-button">
        </button>
        <button pButton pRipple type="button" [label]="'CLIENT_BOOKING.COMP_SESSION' | translate" class="text-sm"
          (click)="ComplimentoryClass(complimentoryForm)" [loading]="isComplimentoryLoading" aria-label="confirm-comp-session-button">
        </button>
      </div>
      <!-- Modal Footer -->
    </form>

  </ng-template>

</p-dialog>
<!-- Comp Session -->

<!-- Show Recurring Event Modal -->
<p-dialog [(visible)]="showRecurringEventUpdatePopup" (onHide)="addToRecurringClass(false)" [resizable]="false" appendTo="body"
  [modal]="true" [breakpoints]="{'767px': '100vw'}" [style]="{width: '350px'}" styleClass="" [blockScroll]="true"
  [closable]="false" aria-label="recurring-event-dialog">

  <ng-template pTemplate="header" styleClass="hidden">{{'SCHEDULE.VIEWAPPOINTMENT.EDIT_RECURRING_EVENT_INFO' | translate}}
  </ng-template>
  <ng-template pTemplate="content" styleClass="p-0">
    <form [formGroup]="addToRecurringClassForm" aria-label="recurring-event-form">
      <ul class="list-none p-0 m-0 text-sm">
        <li class="my-3 flex align-items-start">
          <p-radioButton name="updateEvent" value="thisClass" inputId="option1" formControlName="updateEvent" aria-label="update-this-class-option">
          </p-radioButton>
          <label class="ml-2" for="option1">{{'SCHEDULE.VIEWAPPOINTMENT.THIS_CLASS' | translate}}</label>
        </li>
        <li class="my-3 flex align-items-start">
          <p-radioButton name="updateEvent" value="recurringClass" inputId="option2"
            formControlName="updateEvent" aria-label="update-recurring-classes-option">
          </p-radioButton>
          <label class="ml-2" for="option2">{{'SCHEDULE.VIEWAPPOINTMENT.THIS_AND_FOLLOWING_CLASSES' | translate}}</label>
        </li>
      </ul>
    </form>
  </ng-template>
  <ng-template pTemplate="footer">
    <button pButton pRipple type="button" [label]="'common.BUTTONS.CANCEL-BUTTON-TEXT' | translate"
      class="p-button-secondary p-button-text text-sm" (click)="addToRecurringClass(false)" aria-label="cancel-recurring-event-button">
    </button>
    <button pButton pRipple type="button" [label]="'common.BUTTONS.BUTTON-TEXT-OK' | translate" class="text-sm"
    (click)="addToRecurringClass(true)" [loading]="btnLoading" aria-label="confirm-recurring-event-button"></button>
  </ng-template>

</p-dialog>
<!-- Show Recurring Event Modal -->
